export const publicationMixin = {
  methods: {
    $_publicationMixin_haveSomeConflict(conflicts = []) {
      return conflicts.some(({ status = false } = {}) => status === true);
    },

    $_publicationMixin_countPendingConflict(conflicts = []) {
      let count = conflicts.filter(({ status = false } = {}) => status === true).length;

      return count;
    },

    $_publicationMixin_countPendingTodo(todos = []) {
      let count = todos.filter((todo) => todo.activeFlag === true).length;

      return count;
    }
  }
};
